import {http, onSuccess, onFail} from './http';

export const getRecordsList = (eventPassword) =>
    http.get(`/api/cp/event/${eventPassword}/record/list`)
        .then(onSuccess, onFail);

export const createStreamRecord = (streamID, data) =>
    http.post(`/api/cp/event/stream/${streamID}/record`, data)
        .then(onSuccess, onFail);

export const createEpisodeRecord = (episodeID, data) =>
    http.post(`/api/cp/event/stream/episode/${episodeID}/record`, data)
        .then(onSuccess, onFail);